import './FeatureCardItem.css';
import ScrollAnimation from 'react-animate-on-scroll';
import { canUseDOM, get, injectImageResolution } from '../../utils';
import LazyPicture from '../atoms/LazyPicture';
import RouterLink from '../atoms/RouterLink';
import { ReactComponent as IconChevronRightLight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as IconChevronLeftLight } from '../../resources/icons/IconChevronLeftLight.svg';
import { ReactComponent as ChevronDetLeftIcon } from '../../resources/icons/chevron-left-24-px.svg';
import { ReactComponent as ChevronDetRightIcon } from '../../resources/icons/chevron-right-24-px.svg';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import throttle from 'lodash/throttle';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../utils/tealium';
const FeatureCardItem = props => {
  const [introHeight, setIntroHeight] = useState(0);
  const itemWrapperRef = useRef(null);
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  let countHeights;
  if (canUseDOM) {
    countHeights = throttle(() => {
      if (itemWrapperRef.current) {
        setIntroHeight(itemWrapperRef.current.querySelector('.description').offsetHeight);
      }
    }, 300);
  }
  useEffect(() => {
    if (canUseDOM) {
      setTimeout(countHeights, 500);
      window.addEventListener('resize', countHeights);
    }
    return () => {
      window.removeEventListener('resize', countHeights);
    };
  }, []);
  useEffect(() => {
    setTimeout(countHeights, 500);
  }, [sitecoreContext.selectedFontSize]);
  const title = get(props, 'title.jss');
  const description = get(props, 'description.jss');
  const hasDescription = get(props, 'description.jss.value');
  const hasTitle = get(props, 'title.jss.value');
  const image = get(props, 'image.jss.value.src');
  const alt = get(props, 'image.jss.value.alt');
  const CtaHref = get(props, 'cTALink.jss.value.href');
  const CtaTarget = get(props, 'cTALink.jss.value.target');
  const CtaLinktype = get(props, 'cTALink.jss.value.linktype');
  const {
    eventsAnalytics,
    params,
    isDetSite
  } = props;
  return /*#__PURE__*/React.createElement(RouterLink, {
    className: `${isDetSite ? commonDetStyles : commonStyles} ${!CtaHref && specificStyles}`,
    href: CtaHref,
    linktype: CtaLinktype,
    linksTarget: CtaTarget
  }, /*#__PURE__*/React.createElement("div", {
    className: 'item',
    style: {
      '--descs-height': introHeight
    },
    ref: itemWrapperRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-container",
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), [title.value])
  }, image && /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: `${injectImageResolution(image, 700, props.itemsToShow === 3 ? 700 : 525)}`
  }), /*#__PURE__*/React.createElement("img", {
    src: `${injectImageResolution(image, 768, 768)}`,
    alt: alt
  }))), /*#__PURE__*/React.createElement("div", {
    className: `text-container ${props.itemsToShow !== 3 ? 'text-container-two-items' : ''}`,
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), [title.value])
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, hasTitle && /*#__PURE__*/React.createElement("div", {
    className: "title-wrapper"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "title",
    field: title
  }))), props.mobileDevice ? /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: "description-wrapper"
  }, hasDescription && /*#__PURE__*/React.createElement(Text, {
    className: "description",
    tag: "p",
    field: description
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "description-wrapper"
  }, hasDescription && /*#__PURE__*/React.createElement(Text, {
    className: "description",
    tag: "p",
    field: description
  })), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: "cta-wrapper",
    onClick: e => {
      e.stopPropagation();
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['readMoreAnalytics'], params), [title.value, props.readmore]);
    }
  }, CtaHref && /*#__PURE__*/React.createElement("span", {
    className: "btn-tertiary btn-tertiary--carousel"
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-tertiary__text"
  }, props.readmore), isDetSite ? rtl ? /*#__PURE__*/React.createElement(ChevronDetLeftIcon, null) : /*#__PURE__*/React.createElement(ChevronDetRightIcon, null) : rtl ? /*#__PURE__*/React.createElement(IconChevronLeftLight, null) : /*#__PURE__*/React.createElement(IconChevronRightLight, null)))))));
};
const specificStyles = "s44hcgv";
const commonStyles = "c1ckjc8x";
const commonDetStyles = "cugutjq";
export default FeatureCardItem;